import { type Relations } from "@inrev/common";

export const adminNoteTopicsQueryKey = (relation: Relations.Notes) =>
	["adminNoteTopics", relation.relationType, `${relation.relationId}`] as const;
